import {
  GET_CONTACT_DATA, DELETE_CONTACT_COMMENT, SAVE_CONTACT_COMMENT, SAVE_CONTACT_DATA,
  RESET_CONTACT_DATA, RESET_CONTACT_USER_DATA, GET_CONTACT_USER_DATA, GET_CONTACT_VCARD_DATA, RESET_CONTACT_VCARD_DATA,
  GET_CONTACT_RELATED_CONTACT_LIST_DATA, GET_CONTACT_DEAL_LIST_DATA,
} from '../../constants/system/actions';

const getContactData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_CONTACT_DATA, payload, resolve, reject,
});

const getContactUserData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_CONTACT_USER_DATA, payload, resolve, reject,
});

const getContactVCardData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_CONTACT_VCARD_DATA, payload, resolve, reject,
});

const getContactRelatedContactListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_CONTACT_RELATED_CONTACT_LIST_DATA, payload, resolve, reject,
});

const getContactDealListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_CONTACT_DEAL_LIST_DATA, payload, resolve, reject,
});

const saveContactData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_CONTACT_DATA, payload, resolve, reject,
});

const deleteContactComment: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: DELETE_CONTACT_COMMENT, payload, resolve, reject,
});

const saveContactComment: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_CONTACT_COMMENT, payload, resolve, reject,
});

const resetContactData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_CONTACT_DATA, payload,
});

const resetContactUserData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_CONTACT_USER_DATA, payload,
});

const resetContactVCardData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_CONTACT_VCARD_DATA, payload,
});

export {
  getContactData,
  getContactUserData,
  getContactVCardData,
  getContactRelatedContactListData,
  getContactDealListData,
  saveContactData,
  deleteContactComment,
  saveContactComment,
  resetContactData,
  resetContactUserData,
  resetContactVCardData,
};
